import * as React from "react";

// components
import { Flipper } from "react-flip-toolkit";
import Discover from "./component";
import Trending from "../trending";
import DiscoverContainerHelmet from "./helmet";
import HelloBar from "app/discover/components/helloBar";

// helpers
import { useProps, useHandlers, useEffects } from "./hooks";
import translateAppURLToURL from "@vingle/wtf-sdk/helpers/translateAppURLToURL";

function DiscoverContainer() {
  const hookProps = useProps();
  const hookHandlers = useHandlers(hookProps);
  useEffects(hookProps, hookHandlers);

  const {
    currentUser,
    selectedSection,
    categories,
    sections,
    feed,
    pageState,
    categoryErrorReason,
    showAd,
  } = hookProps;
  const { handleLoadFeedData, handleClickSection } = hookHandlers;
  return (
    <>
      <DiscoverContainerHelmet after={feed.paging.after} />
      {!currentUser && sections[0] && sections[0].previewContents[0] && (
        <HelloBar
          link={translateAppURLToURL(sections[0].previewContents[0].url)}
        />
      )}
      <Flipper
        flipKey={selectedSection}
        decisionData={selectedSection}
        staggerConfig={{
          default: {
            speed: 0.25,
          },
        }}
      >
        <Discover
          categories={categories}
          sections={sections}
          feed={feed}
          showAd={showAd}
          selectedSectionId={selectedSection}
          categoryErrorReason={categoryErrorReason}
          isDiscoverCategoriesLoading={pageState.isDiscoverCategoriesLoading}
          isDiscoverFeedLoading={pageState.isDiscoverFeedLoading}
          isTrendingSectionsLoading={pageState.isTrendingSectionsLoading}
          handleLoadFeedData={handleLoadFeedData}
          onClickSection={handleClickSection}
        />
        <Trending isModal={true} sectionId={selectedSection || undefined} />
      </Flipper>
    </>
  );
}

export default React.memo(DiscoverContainer);
